import { Swatch } from "@components";
import classNames from "classnames";

import type { RenderOptionProps as TilesOptionProps } from "../../../../components/Tiles/TilesV2";
import type { MergedOptionValue } from "../../../services/util/optionRendering";
import selectors from "../selectors";

export default function TilesSwatchOption<T extends MergedOptionValue>({
  disabled,
  image,
  isActive,
  label,
  value,
}: T & TilesOptionProps) {
  return (
    <span
      className="flex flex-col items-center"
      data-testid={selectors.swatchOptionContainer}
      data-swatch-value={label || value}
    >
      <span
        className={classNames("inline-block", {
          "cursor-default": disabled,
          "cursor-pointer": !disabled,
        })}
      >
        {image && (
          <Swatch
            alt={label || value}
            image={image.src}
            borderBehavior={isActive ? "always" : "hover"}
            size="regular"
          />
        )}
      </span>
    </span>
  );
}
